type MaybeArray<T> = T | T[];

export function makeApiUrl(path: string, args?: Record<string, MaybeArray<string | number>>): string {
  const { protocol, hostname, port } = window.location;
  let authority = `//${hostname}`;
  if (port) {
    authority += `:${port}`;
  }

  const base = `${protocol}${authority}`;
  path = `/api/v1/${path}`;
  const url = new URL(path, base);
  for (const [name, value] of Object.entries(args ?? {})) {
    if (Array.isArray(value)) {
      for (const val of value) {
        url.searchParams.append(name, `${val}`);
      }
    } else {
      url.searchParams.set(name, `${value}`);
    }
  }
  return url.toString();
}
